export default {
  namespaced: true,
  state: {
    schemeType: 5,
    swiped: false
  },
  mutations: {
    updateSchemeType (state, val) {
      state.schemeType = val
    },
    updateSwiped (state, val) {
      state.swiped = val
    }
  }
}
